<template>
  <div>
    <span class="subheading">{{title}}</span>
    <v-layout row wrap>
      <v-flex xs3>
        <v-text-field
                      v-model="item.telCode" :label="`區碼`"
                      placeholder="輸入區碼"></v-text-field>
      </v-flex>
      <v-flex xs4>
        <v-text-field
                      v-model="item.phone" :label="`電話`"
                      placeholder="輸入電話"></v-text-field>
      </v-flex>
      <v-flex xs3>
        <v-text-field
                      v-model="item.ext" :label="`分機`"
                      placeholder="輸入分機"></v-text-field>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  export default {
    name: 'CellphoneView',
    props: {
      title: String,
      item: Object,
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CellphoneView.vue